module.exports = __webpack_public_path__ + "static/iphonex-immersion-3fb3fea1a56bff0acbc79afdc2ee6957.png";